export const ESTADO_APROBACION_TICKET = {
  PENDIENTE: 1,
  APROBADO: 2,
  RECHAZADO: 3,
} as const

export type EstadoAprobacionTicketType =
  (typeof ESTADO_APROBACION_TICKET)[keyof typeof ESTADO_APROBACION_TICKET]
